import { render, staticRenderFns } from "./RegisterOK.vue?vue&type=template&id=7c1ff43c&"
import script from "./RegisterOK.vue?vue&type=script&lang=js&"
export * from "./RegisterOK.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports